var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GmapMap',{style:('width: 100%; height:'+_vm.height+'px'),attrs:{"center":_vm.marker,"zoom":14,"map-type-id":"terrain","options":_vm.mapStyle}},[_c('GmapMarker',{attrs:{"position":_vm.marker,"clickable":true,"icon":_vm.markerIcon},on:{"click":function($event){_vm.center=_vm.marker}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }